import { Disposable } from 'record-it-utils/utils/DisposableContainer/DisposableContainer';
export class HooksContainer<THooks extends {
  [hookname: string]: ((...args: Array<any>) => void) | undefined;
}> {
  private registeredHooks: Array<THooks> = [];
  public registerHooks(hooks: THooks): Disposable {
    this.registeredHooks.push(hooks);
    return {
      dispose: () => {
        this.registeredHooks = this.registeredHooks.filter(rh => rh !== hooks);
      }
    };
  }
  public unregisterAllHooks(): void {
    this.registeredHooks = [];
  }
  public callHooks<THookName extends keyof THooks>(hookName: THookName, ...args: Parameters<Exclude<THooks[THookName], undefined>>): void {
    this.registeredHooks.forEach(hooks => {
      const hookCallback = hooks[hookName];
      if (hookCallback) {
        hookCallback.apply(hooks, args);
      }
    });
  }
}